<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: {
    graphData: Array
  },
  mounted () {
    console.log("grafico errori, graphData=",this.graphData)
    this.renderChart({
      labels: ['Lampade OK', 'Lampade non raggiungibili', 'Lampade in errore','Lampade in manutenzione'],
      datasets: [
        {
          backgroundColor: [
            '#33CC33',
            '#aaaaaa',
            '#FF6666',
            '#ffa500'
          ],
          data: this.graphData
        }
      ]
    }, {responsive: true, maintainAspectRatio: false, height: 100})
  }
}
</script>